import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  switchLabel: {
    marginLeft: "0px !important",
  },
}));
